<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">
			<Row>
				<Col>
				<p style="color: #C0C0C0;">操作说明：请先输入设备货道的列数机行数，点击生成货道信息，货道信息无误后，在进行提交</p>
				<p style="color: #C0C0C0;">编号说明：1-1表示第一行第一列的货道</p>
				</Col>
			</Row>
			<Form ref="formValidate" :label-width="80">
				<Row>
					<Col>
					<Alert type="success" v-if="total!=0">货道生成成功，共生成{{total}}个</Alert>
					</Col>
				</Row>
				<h2>自动生成货道：</h2>
				<Row>
					<Col span="7">
					<FormItem label="货道行数" prop="row" class="">
						<Input v-model="row" placeholder="请输入行数" type="number"></Input>
					</FormItem>
					</Col>
					<Col span="7">
					<FormItem label="货道列数" prop="columns" class="">
						<Input v-model="columns" placeholder="请输入货道列数" type="number"></Input>
					</FormItem>
					</Col>
					<Col span="7">
					<FormItem label="最大商品数" prop="columns" class="">
						<Input v-model="maxNumber" placeholder="请输入最大商品数" type="number" ></Input>
					</FormItem>
					</Col>
					<Col span="3">
					<Button type="primary" @click="sc">生成货道</Button>
					</Col>
				</Row>
				<h2>手动生成货道：</h2>
				<Alert type="error" v-if="manualAddState=='1'">编号重复</Alert>
				<Row>
					<Col span="7">
					<FormItem label="编号" prop="number" class="">
						<Input v-model="aisle1.number" placeholder="请输入编号"></Input>
					</FormItem>
					</Col>
					<Col span="7">
					<FormItem label="最大商品数" prop="maxNumber" class="">
						<Input v-model="aisle1.maxNumber" placeholder="请输入最大商品数" type="number"></Input>
					</FormItem>
					</Col>
					<Col span="7">
					<FormItem label="备注" prop="remark" class="">
						<Input v-model="aisle1.remark" placeholder="请输入备注"></Input>
					</FormItem>
					</Col>
					<Col span="3">
					<Button type="primary" @click="manualAdd">新增</Button>
					</Col>
				</Row>
				<FormItem>
					<Button type="primary" @click="add" v-show="macAisle.length>0">提交</Button> 
					<Button type="primary" @click="add" disabled v-show="macAisle.length==0">提交</Button> 
					<Button @click="handleReset" style="margin-left: 8px">清空</Button>
				</FormItem>
				<div class="macAisle">
					<Row v-for="(item,i) in macAisle" :key="item.number">
						<Col span="7">
						<FormItem label="编号" prop="number" class="">
							 <Input v-model="item.number" placeholder="请输入编号" disabled></Input>
						</FormItem>
						</Col>
						<Col span="7">
						<FormItem label="最大商品数" prop="maxNumber" class="">
							<Input v-model="item.maxNumber" placeholder="请输入备注"></Input>
						</FormItem>
						</Col>
						<Col span="7">
						<FormItem label="备注" prop="remark" class="">
							<Input v-model="item.remark" placeholder="请输入备注"></Input>
						</FormItem>
						</Col>
						<Col span="3">
						<Button type="error" @click="deleteAisle(item.number)">删除</Button>
						</Col>
					</Row>
				</div>

			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				loading:false,
				macId:'',
				row: 0, //行数
				columns: 0, //列数
				maxNumber: '', //最大商品数
				remark: '', //备注
				total: 0,
				macAisle: [],
				aisle1: {
					number: '',
					remark: '',
					maxNumber: 6
				},
				manualAddState:0

			}
		},
		created() {
			this.macId=this.$route.query.id
			this.reqPage()
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			add() { //提交信息
				if (this.macAisle.length > 0) {
					this.t=false
					let _this=this
					http.http({
					    //这里是你自己的请求方式、url和data参数
					    method: 'post',
					    url: http.url + '/fac/mac/aisle/add',
					    data: {list:_this.macAisle,macId:_this.macId},
						_this: _this,
						success: function(data) {
							
								_this.$Message.success('新增成功!');
						}
					    //假设后台需要的是表单数据这里你就可以更改
					  })
				
				}else{
					this.$Message.error('请完善信息后再进行提交!');
				}
			},
			handleReset() {
				this.maxNumber = '';
				this.row = '';
				this.columns = ''

			},
			sc() { //生成货道信息
				if(this.row<=0 && this.columns<=0){
					this.$Message.error('请输入正确的行列数!');
					return ;
				}
				if(this.maxNumber<=0){
					this.$Message.error('请输入最大商品数!');
					return ;
				}
				this.macAisle = []
				for (var i = 1; i <= this.row; i++) {
					for (var j = 1; j <= this.columns; j++) {
						this.macAisle.push({
							number: i + '-' + j,
							remark: this.remark,
							maxNumber: this.maxNumber
						})
					}
				}
				this.total = this.macAisle.length
			},
			manualAdd() { //手动生成货道信息
			    if(this.aisle1.number==''){
					this.$Message.error('请输入正确的货道编号!');
					return ;
				}
				 for (let i = 0; i < this.macAisle.length; i++) {
					let obj = this.macAisle[i];
					if (this.aisle1.number == obj.number) {
						this.$Message.error('货道编号重复!');
						return;
					}
				} 
				this.manualAddState=0
				this.$Message.success('生成成功!');
				this.macAisle.push({
							number: this.aisle1.number,
							remark: this.aisle1.remark,
							maxNumber: this.aisle1.maxNumber
						})
			},
			deleteAisle(number) { //删除货道信息
				for (let i = 0; i < this.macAisle.length; i++) {
					let obj = this.macAisle[i];
					if (number == obj.number) {
						this.macAisle.splice(i, 1)
					}
				}
				this.total = this.macAisle.length

			},
			reqPage(){
				this.loading=true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/aisle/page',
				    data: {
						macId:_this.macId,
						page: 0,
						size: 1000
					},
					_this: _this,
					success: function(data) {
						_this.macAisle = data.macAisles.content
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
		}
	}
</script>

<style scoped="scoped">


	.list-btn {
		margin-bottom: 20px;
	}

	.content {
		margin-left: 10%;
		max-width: 1200px;

	}

	.ivu-form-item {
		margin-bottom: 5px;
	}

	.ivu-row {
		/* margin-bottom: 20px; */
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/pcoduction/aisle/update.vue